import { render, staticRenderFns } from "./exhibition-release-new-pass.vue?vue&type=template&id=44c80e55&scoped=true&"
import script from "./exhibition-release-new-pass.vue?vue&type=script&lang=js&"
export * from "./exhibition-release-new-pass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c80e55",
  null
  
)

export default component.exports